//pages

import {
  Dashboard,
  Ministry,
  EditMinistry,
  AddMinistry,
  DetailsMinistry,
  Batch,
  RequestDetails,
  Seemore,
  Setting,
  ChangePassword,

  //category
  AddCategory,
  CategoriesListing,
  UpdateCategory,

  //products
  AddProduct,
  UpdateProduct,
  Products,
} from "./pages";

//routes

import { adminRoutes } from "../../Services/Routes/APP";

//admin routes export

export const adminroutes = [
  {
    id: `admin-122`,
    exact: false,
    path: adminRoutes?.root,
    component: Dashboard,
  },
  {
    id: `admin-123`,
    exact: false,
    path: adminRoutes?.dashboard,
    component: Dashboard,
  },

  //categories

  {
    id: `admin-125-category`,
    exact: false,
    path: adminRoutes?.addCategory,
    component: AddCategory,
  },
  {
    id: `admin-126-category`,
    exact: false,
    path: adminRoutes?.categories,
    component: CategoriesListing,
  },
  {
    id: `admin-126-update-category`,
    exact: false,
    path: adminRoutes?.editCategory,
    component: UpdateCategory,
  },

  //products

  {
    id: `admin-123-add-products`,
    exact: false,
    path: adminRoutes?.addProduct,
    component: AddProduct,
  },

  {
    id: `admin-123-listing-products`,
    exact: false,
    path: adminRoutes?.products,
    component: Products,
  },
  {
    id: `admin-123-update-products`,
    exact: false,
    path: adminRoutes?.editProduct,
    component: UpdateProduct,
  },

  //ministry

  {
    id: `admin-124`,
    exact: false,
    path: adminRoutes?.ministry,
    component: Ministry,
  },

  {
    id: `admin-124`,
    exact: false,
    path: adminRoutes?.editMinistry,
    component: EditMinistry,
  },
  {
    id: `admin-125`,
    exact: false,
    path: adminRoutes?.addMinistry,
    component: AddMinistry,
  },
  {
    id: `admin-126`,
    exact: false,
    path: adminRoutes?.detailsMinistry,
    component: DetailsMinistry,
  },
  // {
  //   id: `admin-127`,
  //   exact: false,
  //   path: adminRoutes?.pouDetail,
  //   component: PouDetails,
  // },
  // {
  //   id: `admin-128`,
  //   exact: false,
  //   path: adminRoutes?.provincesDetails,
  //   component: ProvincesDetails,
  // },
  // {
  //   id: `admin-129`,
  //   exact: false,
  //   path: adminRoutes?.districtsDetails,
  //   component: DistrictDetails,
  // },
  {
    id: `admin-130`,
    exact: false,

    path: adminRoutes?.batch,
    component: Batch,
  },
  {
    id: `admin-130`,
    exact: false,
    path: adminRoutes?.detailsDashboard,
    component: RequestDetails,
  },
  {
    id: `admin-131`,
    exact: false,
    path: adminRoutes?.seemoreDashboard,
    component: Seemore,
  },
  {
    id: `admin-132`,
    exact: false,
    path: adminRoutes?.setting,
    component: Setting,
  },
  {
    id: `admin-133`,
    exact: false,
    path: adminRoutes?.changePasswordAdmin,
    component: ChangePassword,
  },
];
